import { FormControl, FormLabel, TextField, Button, Grid, Card, CardContent, Typography, Paper, Box, Toolbar } from '@mui/material'
import React, { useState } from 'react'
import { defaultApi } from '../../api-interface';
import { redirect, useNavigate } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from "yup"
import { SnackbarProvider } from 'notistack';
import { enqueueSnackbar } from 'notistack';


export async function loader() {
    try {
        await defaultApi.readUsersMeMeGet()
        return redirect("/dashboard")
    } catch {
        return null
    }
}

const Login = () => {

    const navigate = useNavigate()

    const [unauthorised, setUnauthorised] = useState(false)

    const schema = yup
        .object({
            username: yup.string().email("Email must be a valid email").required(),
            password: yup.string().required(),
        })
        .required()

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    })

    const handleLogin = async (values) => {
        setUnauthorised(false)
        try {
            const res = await defaultApi.loginForAccessTokenTokenPost(values.username, values.password)
            // Get the redirect URL from the URL params
            const redirectUrl = new URLSearchParams(window.location.search).get('next')
            navigate(redirectUrl ? redirectUrl : "/dashboard")
        } catch (e) {
            if (e?.response?.status == 401) {
                setUnauthorised(true)
            }
            else {
                enqueueSnackbar(e, { variant: "error" })
            }
            
        }
    }

    return (
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
            <Toolbar />
                <SnackbarProvider anchorOrigin={{ horizontal: "center", vertical: "top" }}>
            
            <Box display={"flex"} flexDirection={"row"} gap={2} justifyContent={"center"}>
            <Paper elevation={6} sx={{ minWidth: 320}}>
                <CardContent>
                    <form onSubmit={handleSubmit(handleLogin)}>
                        <FormControl fullWidth>
                            <Typography align="center" variant="h5">Login</Typography>
                            <TextField
                                margin="normal"
                                label="Email Address"
                                placeholder="Email Address"
                                {...register('username')}
                                error={errors.username ? true : false}
                                helperText={errors.username?.message?.toString()}
                                type="text"
                                variant='outlined'
                                autoComplete='email'
                                required
                            />
                            <TextField
                                margin="normal"
                                label="Password"
                                {...register('password')}
                                error={errors.password ? true : false}
                                helperText={errors.password?.message?.toString()}
                                type="password"
                                variant='outlined'
                                autoComplete='current-password'
                                required
                            />
                            <Button variant="contained" type="submit">Login</Button>
                            <Typography color="error" align="center" display={unauthorised ? "block" : "none"}>
                                Unable to login, incorrect username or password
                            </Typography>
                        </FormControl>
                    </form>
                </CardContent>
            </Paper>
            </Box>
            </SnackbarProvider>
        </Box>
    )
}

export default Login